import {useState, useEffect, useCallback} from "react";
import {useForm, Controller} from "react-hook-form";
import {Col, Row, Table, notification} from "antd";
import {Button, Loading} from "~/components";
import {InputField, InputPriceField, DateField} from "~/components/Forms";
import {apiError, handleRequest, numberFormat, renderDate, strToTime} from "~/utils";
import {marketingProjectApi} from "~/api";

function MarketingProjectFormBudget({item, onUpdated}) {

	const [loading, setLoading] = useState(false);
	const [logs, setLogs] = useState([]);

	const initialValues = {
		date: new Date(),
		budgetNeeded: item?.budgetDailyNeeded || 0,
		budgetSpent: 0,
		note: '',
	};

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({defaultValues: initialValues});

	const loadLogs = useCallback(async () => {
		setLoading(true);
		const [error, response] = await handleRequest(marketingProjectApi.dailyLogs(item.id));
		if (!error && response) setLogs(Array.isArray(response.data) ? response.data : (response.data?.data || []));
		setLoading(false);
	}, [item.id]);

	useEffect(() => { loadLogs().then(); }, [loadLogs]);

	const onSubmit = async (data) => {
		const [error, response] = await handleRequest(marketingProjectApi.dailyLog({
			id: item.id,
			date: strToTime(data.date),
			budgetNeeded: data.budgetNeeded || 0,
			budgetSpent: data.budgetSpent || 0,
			note: data.note,
		}));
		const message = apiError('Cập nhật ngân sách ngày thất bại', error, response);
		if (!message) {
			notification.success({message: 'Thành công', description: 'Đã cập nhật ngân sách ngày'});
			reset({date: new Date(), budgetNeeded: data.budgetNeeded, budgetSpent: 0, note: ''});
			await loadLogs();
			if (onUpdated) onUpdated();
		}
	}

	const columns = [
		{title: 'Ngày', dataIndex: 'date', width: 110, render: (t) => renderDate(t)},
		{title: 'Cần chi', dataIndex: 'budgetNeeded', align: 'right', render: (v) => numberFormat(v) + 'đ'},
		{title: 'Đã chi', dataIndex: 'budgetSpent', align: 'right', render: (v) => <b style={{color: 'var(--green)'}}>{numberFormat(v)}đ</b>},
		{title: 'Ghi chú', dataIndex: 'note'},
	];

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{(loading || isSubmitting) && <Loading/>}
			<p className="heading">Ghi ngân sách ngày — {item?.name}</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="date" render={({field}) => (
						<DateField label="Ngày" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="budgetNeeded" render={({field}) => (
						<InputPriceField label="Ngân sách cần chi" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="budgetSpent" render={({field}) => (
						<InputPriceField label="Ngân sách đã chi" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="note" render={({field}) => (
						<InputField label="Ghi chú" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Lưu ngân sách ngày</Button>
			</div>
			<p className="heading">Lịch sử ngân sách theo ngày</p>
			<Table rowKey="id" size="small" columns={columns} dataSource={logs} pagination={{pageSize: 10}} locale={{emptyText: 'Chưa có nhật ký ngân sách'}}/>
		</form>
	)
}

export default MarketingProjectFormBudget;
